import { find } from 'lodash';
import features from 'lib/common/features';

/**
 * Messages for box seats are provided as Web Content in the response from Tessitura.
 * We use zone no information in price type work out which box type is selected
 * and then extract appropriate box information from the web content.
 *
 * @param  Object seatData
 * @param  array  webContents
 * @param  array  priceTypes
 * @return array
 */
export default function filterMessages(seatData, webContents, priceTypes) {
  if (features.isEnabled('seatWebContentMessages') === false) {
    return null;
  }

  if (!webContents.length) {
    return null;
  }

  let priceType = find(priceTypes, function(priceType) {
    return seatData.zone_no === parseInt(priceType.zone_no, 10);
  });

  if (!priceType) {
    return null;
  }

  let message;

  message = find(webContents, function(webContent) {
    return webContent.content_type_desc.indexOf(priceType.price_type_desc) > -1;
  });

  if (!message) {
    // Do the same but with zones
    message = find(webContents, function(webContent) {
      return webContent.content_type_desc.indexOf(priceType.zone_desc) > -1;
    });
  }

  if (!message) {
    return null;
  }

  return message.content_value.replace(/(?:\r\n|\r|\n)/g, '<br />');
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/messageFromWebContents.js